<div class="oi-main-dshd">

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="oi-comen-heading">
          <div class="row">
            <div class="col-md-4">
              <h2>Trending Questions</h2>
            </div>
            <div class="col-md-3">
              <div class="search-trd-mn d-flex">
                <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm"
                  (ngModelChange)="onSearchInputChange()" />
                <button type="button" class="search-trd-btn" (click)="searchTrendingQuestions()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="">
                    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                    <path d="M21 21l-6 -6" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="col-md-2">
              <div class="oi-select-fld1 trddrop">
                <p-dropdown [options]="availableFilter" [(ngModel)]="selectedSearchOption" optionLabel="searchFilter" 
                  optionValue="searchFilter" placeholder="Select a Search option" (onChange)="changeSearchOption($event)"></p-dropdown>
              </div>

            </div>

            <div class="col-md-3">
              <div class="oi-select-fld1 trddrop">
                <p-dropdown [options]="availableCollections" [(ngModel)]="selectedCollection"
                  optionLabel="collectionName" optionValue="collectionName" placeholder="Select a Collection"
                  (onChange)="changeCollection($event, availableCollections)"></p-dropdown>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>





    <ng-container *ngIf="loader else showcontent">
      <div class="imgloader" *ngIf="loader">
        <img src="../../assets/img/loader.gif">
      </div>
    </ng-container>
    <ng-template #showcontent>
      <div class="row">
        <div class="col-md-12">
          <div class="oi-table1 oi-tred-mt">
            <div class="table">
              <p-table [value]="trending_questions" [scrollable]="true" scrollHeight="calc(100vh - 100px)" [rows]="10">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th style="width:5%"> </th>
                    <th style="width:50%">Questions </th>
                    <th style="width:5%" class="text-center">Verified</th>
                    <th style="width:5%" class="text-center">Views</th>
                    <th style="width:15%" class="text-center">Linked Docs</th>
                    <th style="width:20%" class="trndcntr">Action</th>
                    <!-- <th class="text-center">Action</th> -->
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-tredndingques let-columns="columns">
                  <tr>
                    <td>
                      <div class="pq-button-plus" (click)="toggleRow(tredndingques)">
                        <img *ngIf="!isRowExpanded(tredndingques)" src="../../assets/img/pq-plus.svg">
                        <img *ngIf="isRowExpanded(tredndingques)" src="../../assets/img/pq-minus.svg">
                      </div>
                    </td>
                    <!-- <td style="width:3%" class="qns-check"><img *ngIf="tredndingques.answer_approved==1"
                                          src="../../assets/img/badge.png"> </td> -->
                    <td class="qns-check trtb1-brdr1" [innerHTML]="tredndingques.question | highlight:searchTerm"></td>
                    <td class="text-center">
                      <div *ngIf="tredndingques.answer_approved == 1" class="pq-yes">Yes</div>
                      <div *ngIf="tredndingques.answer_approved != 1" class="pq-no">No</div>
                    </td>
                    <td class="text-center">{{tredndingques.views}}</td>
                    <td class="text-center">
                      <div class="link-doc" *ngIf="tredndingques.document_count > 1">{{tredndingques.document_count}}</div>
                      <div class="link-doc drk" *ngIf="tredndingques.document_count <= 1">{{tredndingques.document_count}}</div>
                    </td>
                    <td  class="trndcntr">
                      <span class="tbl-icon" [ngClass]="tredndingques.is_bookmarked == 1 ? 'active-bookmark':''" (click)="fnQuesBookmark(tredndingques)">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" class="">
                          <path
                            d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
                        </svg>
                      </span>
                      <span (click)="confirmQuestionDelete(tredndingques)">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" class="">
                          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                          <path d="M10 10l4 4m0 -4l-4 4" />
                        </svg>
                      </span>
                      <!-- <img (click)="pinUnpin(tredndingques)" class="fa fa-thumb-tack"
                        [src]="tredndingques.pinned===0?'../../assets/img/thumbtack.svg':'../../assets/img/thumbtack-click.svg'"
                        width="16px"> -->
                      <img src="../assets/img/eye.svg" width="16px" (click)="viewQuest(tredndingques)" class="tr-ac-vv">
                    </td>
                  </tr>
                  <tr *ngIf="isRowExpanded(tredndingques)">
                    <td colspan="6">
                      <div class="pq-expendtxt">
                        <strong>Linked Documents:</strong><br>
                        <ng-container *ngIf="loaderDoc">
                          <div class="imgloader1" *ngIf="loaderDoc">
                            <img src="../../assets/img/loader.gif">
                          </div>
                        </ng-container>
                        <ng-container *ngIf="questionDocuments && questionDocuments.length > 0; else noDoc">
                          <div class="doc-item" *ngFor="let doc of questionDocuments; let i = index">
                            {{ doc.document_name }}
                            <a 
                              href="javascript:void(0)" 
                              *ngIf="doc.document_name" 
                              class="link-pq-rd" 
                              (click)="confirmDelete(tredndingques, doc, $event)">
                              [Remove]
                            </a>
                          </div>
                        </ng-container>

                        <ng-template #noDoc>
                          <div>No documents</div>
                        </ng-template>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="6" class="text-center">No data</td>
                  </tr>
                </ng-template>
              </p-table>
              <div *ngIf="trending_questions?.length>0">
                <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                  [totalRecords]="totalrecords"></p-paginator>
              </div>
            </div>
          </div>

        </div>
      </div>


      <p-confirmDialog></p-confirmDialog>     

    </ng-template>

  </div>
</div>
<p-toast></p-toast>